import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SubmissionError, reset } from 'redux-form';
import { formatValidationErrors } from '../common/utils/getApiReducer';
import Icon from '../common/icons/Icon';
import { Modal } from 'synfrastructure';
import AddEditBadgeForm from './AddEditBadgeForm';
import DeleteForm from '../common/forms/DeleteForm';
import dataUrlToFile from '../common/utils/dataUrlToFile';
import { addBadge, deleteBadge, editBadge } from './actions';

class BadgeListPage extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    badges: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      editingBadge: null,
      addEditBadgeModalVisible: false,
      clearOrigImage: false,
      deleteBadgeId: null,
      deleteBadgeModalVisible: false,
      deleteBadgeName: null,
    };
  }

  toggleAddEditBadgeModal = editingBadge => {
    this.setState(state => {
      if (state.addEditBadgeModalVisible) {
        this.props.dispatch(reset('addEditBadge'));
      }

      return {
        editingBadge,
        addEditBadgeModalVisible: !state.addEditBadgeModalVisible,
        clearOrigImage: false,
      };
    });
  };

  toggleDeleteBadgeModal = (id, name) => {
    if (this.state.deleteBadgeModalVisible) {
      this.props.dispatch(reset('deleteForm'));
      this.setState(state => ({
        deleteBadgeId: null,
        deleteBadgeModalVisible: false,
        deleteBadgeName: null,
      }));
    } else {
      this.setState(state => ({
        deleteBadgeId: id,
        deleteBadgeModalVisible: true,
        deleteBadgeName: name,
      }));
    }
  };

  onAddEditBadgeSubmit = values => {
    const { dispatch } = this.props;
    const { editingBadge, clearOrigImage } = this.state;

    if (values.image) {
      values.image = dataUrlToFile(values.image.imageResult, values.image.imageFilename);
    }

    if (editingBadge && !clearOrigImage) {
      values.image_id = editingBadge.get('image_id');
    }

    return dispatch(editingBadge ? editBadge(editingBadge.get('id'), values) : addBadge(values)).then(action => {
      if (!action.response.ok) {
        throw new SubmissionError(formatValidationErrors(action.json).toJS());
      } else {
        this.toggleAddEditBadgeModal();
      }
    });
  };

  onDeleteBadgeSubmit = () => {
    const { dispatch } = this.props;

    return dispatch(deleteBadge(this.state.deleteBadgeId)).then(action => {
      if (!action.response.ok) {
        throw new SubmissionError(formatValidationErrors(action.json).toJS());
      } else {
        this.toggleDeleteBadgeModal();
      }
    });
  };

  removeImage = () => {
    this.setState(state => ({
      clearOrigImage: true,
    }));
  };

  render() {
    const { badges } = this.props;
    const {
      editingBadge,
      addEditBadgeModalVisible,
      clearOrigImage,
      deleteBadgeModalVisible,
      deleteBadgeName,
    } = this.state;

    return (
      <div className="admin-paper">
        {addEditBadgeModalVisible ? (
          <Modal isVisible={addEditBadgeModalVisible} onClose={this.toggleAddEditBadgeModal}>
            <AddEditBadgeForm
              badge={editingBadge}
              clearOrigImage={clearOrigImage}
              initialValues={editingBadge ? { name: editingBadge.get('name') } : {}}
              onSubmit={this.onAddEditBadgeSubmit}
              onCancel={this.toggleAddEditBadgeModal}
              removeImage={this.removeImage}
            />
          </Modal>
        ) : null}
        <Modal isVisible={deleteBadgeModalVisible} onClose={this.toggleDeleteBadgeModal}>
          <DeleteForm
            entityType="Badge"
            initialValues={{ name: null }}
            onSubmit={this.onDeleteBadgeSubmit}
            onCancel={this.toggleDeleteBadgeModal}
            requiredConfirmationText={deleteBadgeName}
          />
        </Modal>
        <div className="admin-paper__header">
          <h3>Badges</h3>
          <button onClick={this.toggleAddEditBadgeModal.bind(this, null)} className="admin__add-button">
            <Icon icon="Plus" /> Add Badge
          </button>
        </div>
        <ul className="admin-paper__list">
          {badges.get('data').size ? (
            badges.get('data').map(badge => (
              <li key={`badge-${badge.get('id')}`}>
                <div className="admin__badge">
                  <img src={badge.getIn(['image', 'location'])} alt={badge.get('name')} />
                  {badge.get('name')}
                </div>
                <div className="admin-paper__list__actions">
                  <button onClick={this.toggleAddEditBadgeModal.bind(this, badge)}>
                    <Icon icon="Pencil" />
                  </button>
                  <button onClick={this.toggleDeleteBadgeModal.bind(this, badge.get('id'), badge.get('name'))}>
                    <Icon icon="Trash" />
                  </button>
                </div>
              </li>
            ))
          ) : (
            <div className="admin-paper__no-content">There are currently no badges</div>
          )}
        </ul>
      </div>
    );
  }
}

export default connect(state => ({
  badges: state.badges.badges,
}))(BadgeListPage);



// WEBPACK FOOTER //
// ./src/badges/BadgeListPage.js